import { inject, Injector, provideAppInitializer } from '@angular/core';

import { initAuthFactory, registerLocaleFactory } from './factories';

/**
 * App initializers
 */
export const APP_INITIALIZERS = [
  provideAppInitializer(() => {
    const initializerFn = initAuthFactory(inject(Injector));
    return initializerFn();
  }),
  provideAppInitializer(() => {
    const initializerFn = registerLocaleFactory(inject(Injector));
    return initializerFn();
  }),
];
